export default "assets/images/icons/cloud-arrow-down-215e4b7e.svg";